export default __webpack_public_path__ + "static/media/dog2.0f9cc939.svg";